import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=2385411c&scoped=true&lang=pug&"
import script from "./userCard.vue?vue&type=script&lang=js&"
export * from "./userCard.vue?vue&type=script&lang=js&"
import style0 from "./userCard.vue?vue&type=style&index=0&id=2385411c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385411c",
  null
  
)

export default component.exports